import React from 'react'
import { Body, Box, H4 } from '../layout'
import { PriceTiers } from './PriceTiers'
import { partner } from '../../prices'
import { Bullets } from './Bullets'

export const PartnerPricing = () => {
  return (
    <Box
      column
      width={980}
      maxWidth="calc(100vw - 48px)"
      minHeight={488}
      p={16}
      gap={24}
      r={16}
      border="1px solid white"
      shadow="2px 2px 0px 0px white"
      background="black"
      color="white"
    >
      <H4 align="left">Pricing</H4>

      <PriceTiers tiers={partner} />

      <Bullets items={[
        <Box key={0} column gap={4}>
          <Body small bold>Manage clients</Body>
          <Body small>Simplify client management with our easy-to-navigate dashboard. Instantly access and manage all client data and performance, ensuring a seamless experience for you and clients.</Body>
        </Box>,
        <Box key={1} column gap={4}>
          <Body small bold>Access to the P&H partner facilitator network</Body>
          <Body small>Join Hive and access a dynamic resource hub for facilitators. Benefit from ongoing expert guidance, learn practical tips and tricks, and collaborate with a vibrant international network to enhance your skills.</Body>
        </Box>,
        <Box key={2} column gap={4}>
          <Body small bold>Continuous help and support</Body>
          <Body small>As your partner, we are invested in your  success. Our trained Customer Support specialists are readily available to provide expert assistance whenever you need it.</Body>
        </Box>,
      ]} />
    </Box>
  )
}